<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleAdd"><a-icon type="plus" />新增轮播</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <a-table :loading="loading" rowKey="id" :columns="columns" :data-source="list" :pagination="false">
        <span slot="imageUrl" slot-scope="text">
          <oss-img v-if="text" :src="text" class="thumb-img clickable" />
        </span>
        <span slot="linkType" slot-scope="text">
          {{ linkTypeLabel(text) }}
        </span>
        <span slot="jumpTarget" slot-scope="text, record">
          <span v-if="record.linkType === 1">{{ appPageLabel(record.appPage) }}</span>
          <span v-else>{{ record.linkUrl || '—' }}</span>
        </span>
        <span slot="status" slot-scope="text">
          <a-tag v-if="text === 1" color="green">启用</a-tag>
          <a-tag v-else color="red">禁用</a-tag>
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a @click="handleDelete(record)">删除</a>
        </span>
      </a-table>
      <a-pagination
        class="ant-table-pagination"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        @change="changePage"
      />
    </a-card>

    <a-modal :title="formTitle" :visible="open" @ok="submitForm" @cancel="open = false" :confirmLoading="submitLoading">
      <a-form-model :model="form" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
        <a-form-model-item label="标题">
          <a-input v-model="form.title" placeholder="标题" />
        </a-form-model-item>
        <a-form-model-item label="轮播图" prop="imageUrl">
          <file-upload v-model="form.imageUrl" type="image" @change="val => (form.imageUrl = val)" />
        </a-form-model-item>
        <a-form-model-item label="跳转类型" required>
          <a-radio-group v-model="form.linkType" @change="onLinkTypeChange">
            <a-radio :value="1">跳转APP页面</a-radio>
            <a-radio :value="2">APP内打开</a-radio>
            <a-radio :value="3">浏览器打开</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item v-if="form.linkType === 1" label="APP页面" required>
          <a-radio-group v-model="form.appPage">
            <a-radio :value="1">客服</a-radio>
            <a-radio :value="2">兑换卡提交</a-radio>
            <a-radio :value="3">分享</a-radio>
            <a-radio :value="4">优惠券</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item v-if="form.linkType === 2 || form.linkType === 3" label="跳转链接" required>
          <a-input v-model="form.linkUrl" placeholder="请输入 URL" />
        </a-form-model-item>
        <a-form-model-item label="排序">
          <a-input-number v-model="form.sort" :min="0" style="width:100%" />
        </a-form-model-item>
        <a-form-model-item label="状态">
          <a-select v-model="form.status" style="width:100%">
            <a-select-option :value="1">启用</a-select-option>
            <a-select-option :value="0">禁用</a-select-option>
          </a-select>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </page-header-wrapper>
</template>

<script>
import { pageBanner, saveBanner, deleteBanner } from '@/api/giftcard/banner'

const LINK_TYPE_MAP = { 1: '跳转APP页面', 2: 'APP内打开', 3: '浏览器打开' }
const APP_PAGE_MAP = { 1: '客服', 2: '兑换卡提交', 3: '分享', 4: '优惠券' }

export default {
  name: 'GiftcardBanner',
  data() {
    return {
      loading: false,
      submitLoading: false,
      open: false,
      formTitle: '',
      list: [],
      total: 0,
      queryParam: { pageNum: 1, pageSize: 10 },
      form: {
        id: null,
        title: '',
        imageUrl: '',
        linkUrl: '',
        linkType: 2,
        appPage: undefined,
        sort: 0,
        status: 1
      },
      columns: [
        { title: 'ID', dataIndex: 'id', width: 70 },
        { title: '标题', dataIndex: 'title', width: 120 },
        { title: '图片', dataIndex: 'imageUrl', scopedSlots: { customRender: 'imageUrl' }, width: 140 },
        { title: '跳转类型', dataIndex: 'linkType', scopedSlots: { customRender: 'linkType' }, width: 120 },
        { title: '跳转目标', scopedSlots: { customRender: 'jumpTarget' }, ellipsis: true },
        { title: '排序', dataIndex: 'sort', width: 70 },
        { title: '状态', dataIndex: 'status', scopedSlots: { customRender: 'status' }, width: 80 },
        { title: '操作', scopedSlots: { customRender: 'operation' }, width: 120 }
      ]
    }
  },
  created() {
    this.getList()
  },
  methods: {
    linkTypeLabel(type) {
      return LINK_TYPE_MAP[type] || '—'
    },
    appPageLabel(page) {
      return APP_PAGE_MAP[page] || '—'
    },
    onLinkTypeChange() {
      if (this.form.linkType === 1) {
        this.form.linkUrl = ''
        if (!this.form.appPage) {
          this.form.appPage = 1
        }
      } else {
        this.form.appPage = undefined
      }
    },
    getList() {
      this.loading = true
      pageBanner(this.queryParam).then(res => {
        this.list = res.data.records || []
        this.total = res.data.total || 0
      }).finally(() => { this.loading = false })
    },
    changePage(page, pageSize) {
      this.queryParam.pageNum = page
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    resetForm() {
      this.form = {
        id: null,
        title: '',
        imageUrl: '',
        linkUrl: '',
        linkType: 2,
        appPage: undefined,
        sort: 0,
        status: 1
      }
    },
    handleAdd() {
      this.resetForm()
      this.formTitle = '新增轮播'
      this.open = true
    },
    handleEdit(record) {
      this.form = {
        ...record,
        linkType: record.linkType != null ? record.linkType : 2,
        appPage: record.linkType === 1 ? record.appPage : undefined
      }
      this.formTitle = '编辑轮播'
      this.open = true
    },
    submitForm() {
      const imageUrl = (this.form.imageUrl || '').trim()
      if (!imageUrl) {
        this.$message.warning('请上传轮播图')
        return
      }
      if (this.form.linkType === 1 && !this.form.appPage) {
        this.$message.warning('请选择 APP 内置页面')
        return
      }
      if ((this.form.linkType === 2 || this.form.linkType === 3) && !(this.form.linkUrl || '').trim()) {
        this.$message.warning('请填写跳转链接')
        return
      }
      this.form.imageUrl = imageUrl
      if (this.form.linkType === 1) {
        this.form.linkUrl = ''
      } else {
        this.form.appPage = undefined
        this.form.linkUrl = this.form.linkUrl.trim()
      }
      this.submitLoading = true
      saveBanner(this.form).then(() => {
        this.$message.success('保存成功')
        this.open = false
        this.getList()
      }).finally(() => { this.submitLoading = false })
    },
    handleDelete(record) {
      const self = this
      this.$confirm({
        title: '确认删除该轮播？',
        onOk() {
          return deleteBanner(record.id).then(() => {
            self.$message.success('删除成功')
            self.getList()
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.thumb-img {
  width: 120px;
  height: 48px;
  object-fit: cover;
  border-radius: 4px;
}
.thumb-img.clickable {
  cursor: pointer;
}
</style>
